import classNames from 'classnames';
import React, { forwardRef, PropsWithChildren } from 'react';
import Size from '../types/size';
import { getConfigBg } from '../tools/config-bg';
import { twMerge } from 'tailwind-merge';
import { Element } from 'react-scroll';

type Props = {
  componentKey: string;
  componentInstanceKey: string;
  properties?: {
    vertical_margin?: string;
    horizontal_margin?: string;
    background?: string;
  };
  className?: string;
  style?: React.CSSProperties;
  top?: number;
};

const Container = forwardRef<HTMLDivElement, PropsWithChildren<Props>>(
  ({ componentKey, componentInstanceKey, properties, children, className, style, top }, ref) => {
    const bgStyle = getConfigBg(properties?.background);

    return (
      <section
        ref={ref}
        data-module={componentKey}
        id={componentInstanceKey}
        className={twMerge(
          className,
          classNames({
            'py-2.5': properties?.vertical_margin === Size.small,
            'py-5': properties?.vertical_margin === Size.middle,
            'py-10': properties?.vertical_margin === Size.large,
            'px-2': properties?.horizontal_margin === Size.small,
            'px-3': properties?.horizontal_margin === Size.middle,
            'px-5': properties?.horizontal_margin === Size.large
          })
        )}
        style={{
          ...bgStyle,
          ...style,
          scrollMarginTop: (top ?? 0) + 65 + 'px'
        }}
        data-testid={`mod-${componentKey}`}>
        <Element name={componentInstanceKey}>{children}</Element>
      </section>
    );
  }
);

export default Container;
